import { juniorKids as juniorKidsData } from '../../SizeGuideData';
import { renderTableByColumns } from '../../size_guide_helpers';

const juniorKids = () => [
  { tab: 'tab_clothing', label: 'Clothing', contentGenerator: () => renderTableByColumns(juniorKidsData.clothing, 1) },
  { tab: 'tab_shoes', label: 'Shoes', contentGenerator: () => renderTableByColumns(juniorKidsData.shoes, 1) },
  { tab: 'tab_belts', label: 'Belts', contentGenerator: () => renderTableByColumns(juniorKidsData.belts, 1) },
  { tab: 'tab_hats', label: 'Hats', contentGenerator: () => renderTableByColumns(juniorKidsData.hats, 1) },
];

export default juniorKids;
